import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "theme", "inlineCollapsed", "expandIcon", "getPopupContainer"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import RcMenu from 'rc-menu';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined';
import devWarning from '../../_utils/devWarning';
import { cloneElement } from '../../_utils/reactNode';
import MenuContext from './MenuContext';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
export var Menu = function Menu(props) {
  var className = props.className,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    _props$inlineCollapse = props.inlineCollapsed,
    inlineCollapsed = _props$inlineCollapse === void 0 ? false : _props$inlineCollapse,
    expandIcon = props.expandIcon,
    getPopupContainer = props.getPopupContainer,
    restProps = _objectWithoutProperties(props, _excluded);
  React.useEffect(function () {
    devWarning(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
    devWarning(!('inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
  }, [inlineCollapsed, props]);
  var passedProps = omit(restProps, ['collapsedWidth']);
  var prefixCls = usePrefixCls('menu');
  var menuClassName = classNames("".concat(prefixCls, "-").concat(theme), className);
  var contextValue = React.useMemo(function () {
    return {
      prefixCls: prefixCls,
      inlineCollapsed: inlineCollapsed,
      antdMenuTheme: theme,
      firstLevel: true,
      disableMenuItemTitleTooltip: false
    };
  }, [prefixCls, inlineCollapsed, theme]);
  return React.createElement(MenuContext.Provider, {
    value: contextValue
  }, React.createElement(RcMenu, _objectSpread(_objectSpread({
    getPopupContainer: getPopupContainer,
    overflowedIndicator: React.createElement(EllipsisOutlined, null),
    overflowedIndicatorPopupClassName: "".concat(prefixCls, "-").concat(theme)
  }, passedProps), {}, {
    inlineCollapsed: inlineCollapsed,
    className: menuClassName,
    prefixCls: prefixCls,
    expandIcon: cloneElement(expandIcon, {
      className: "".concat(prefixCls, "-submenu-expand-icon")
    })
  })));
};